import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createWhiteLableSettelmentFundReport = (set, get) => ({
    whiteLableSettelmentFundReport: {
        loading: false,
        data: []
    },
    getWhiteLableSettelmentFundReport: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ whiteLableSettelmentFundReport: { ...state.whiteLableSettelmentFundReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/white-lable-settelment-fund-report/${params.fromDate}/${params.toDate}`,
                headers: { token }
            });
            set(() => ({ whiteLableSettelmentFundReport: { loading: false, data: resp.data.Items } }));
        } catch (error) {
            set(() => ({ whiteLableSettelmentFundReport: { loading: false, data: [] } }));
        }
    }
});
